import type { DayOfWeek } from '@/shared/apollo-api';

class _WeekdaysHelper {
  private static _instance: _WeekdaysHelper;

  public static getInstance() {
    if (!_WeekdaysHelper._instance) {
      _WeekdaysHelper._instance = new _WeekdaysHelper();
    }

    return _WeekdaysHelper._instance;
  }

  private mapWeekdays: Map<string, string>;

  private constructor() {
    this.initWeekdays();
  }

  private initWeekdays() {
    this.mapWeekdays = new Map();

    this.mapWeekdays.set('MONDAY', 'Понедельник');
    this.mapWeekdays.set('TUESDAY', 'Вторник');
    this.mapWeekdays.set('WEDNESDAY', 'Среда');
    this.mapWeekdays.set('THURSDAY', 'Четверг');
    this.mapWeekdays.set('FRIDAY', 'Пятница');
    this.mapWeekdays.set('SATURDAY', 'Суббота');
    this.mapWeekdays.set('SUNDAY', 'Воскресенье');
  }

  public getDayName(key: DayOfWeek) {
    return this.mapWeekdays.get(key);
  }
}

export const WeekdaysHelper = _WeekdaysHelper.getInstance();
